import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ProgramSendFaxPage } from './program-send-fax';

@NgModule({
  declarations: [
    ProgramSendFaxPage,
  ],
  imports: [
    IonicPageModule.forChild(ProgramSendFaxPage),
  ],
})
export class ProgramSendFaxPageModule {}



// WEBPACK FOOTER //
// ./src/pages/program-send-fax/program-send-fax.module.ts